import React from 'react';
import './App.css';

function ComingSoon() {
  return (
    <div className="dashboard">
      <div className="coming-soon-container">
        <div className="coming-soon-content">
          <h1 className="coming-soon-title">Slugtopia</h1>
          <h2 className="coming-soon-subtitle">Coming Soon</h2>
          <p className="coming-soon-description">
            Stay tuned for updates!
          </p>
          <a href="/" className="back-btn">
            ← Back to Dashboard
          </a>
        </div>
      </div>
    </div>
  );
}

export default ComingSoon;
